import { useTheme } from "@mui/material";
import { CarPortfolioChartItem } from "@app/pages/assetAllocation/asset-allocation-types";
import {
  CarPdfHeader,
  CarPdfHeaderCell,
  CarPdfRow,
  CarPdfTable,
  CarPdfTableProps,
  CarPdfTextCell,
} from "@app/components/PdfTable";
import { getMultiPeriodReturnComparisonExcelTable } from "@app/pages/assetAllocation/editPortfolioGroup/TableMultiPeriodReturnComparison";
import {
  ExcelDataFormat,
  excelTableFormatValue,
} from "@app/hooks/useExcelExport";

interface MultiPeriodReturnPdfTableProps
  extends Omit<CarPdfTableProps, "children" | "collWidths"> {
  data: CarPortfolioChartItem[];
  data1Id: string;
  data2Id: string;
}

export const MultiPeriodReturnPdfTable = ({
  data,
  data1Id,
  data2Id,
  ...props
}: MultiPeriodReturnPdfTableProps) => {
  const theme = useTheme();

  const table = getMultiPeriodReturnComparisonExcelTable({
    data,
    data1Id,
    data2Id,
  });

  return (
    <CarPdfTable
      colWidths={table.columns.map(() => 1)}
      isRounded
      isStriped
      {...props}
    >
      <CarPdfHeader paddingVertical={14} key="label">
        {table.columns.map((i, idx) => (
          <CarPdfHeaderCell key={idx}>{i.label}</CarPdfHeaderCell>
        ))}
      </CarPdfHeader>
      {table.rows.map((row, rowIdx) => (
        <CarPdfRow key={rowIdx} paddingVertical={10}>
          {row.map((value, valueIdx) => (
            <CarPdfTextCell
              key="label"
              style={{
                textAlign:
                  table.columns[valueIdx].format === ExcelDataFormat.general
                    ? "left"
                    : "center",
                paddingHorizontal: 15,
              }}
            >
              {excelTableFormatValue(value, table.columns[valueIdx])}
            </CarPdfTextCell>
          ))}
        </CarPdfRow>
      ))}
    </CarPdfTable>
  );
};
